/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Company plus computed aggregates for detail screens.
 * @export
 * @interface CompanyDetailed
 */
export interface CompanyDetailed {
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailed
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailed
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailed
     */
    domain?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailed
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailed
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyDetailed
     */
    readonly stripeCustomerId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CompanyDetailed
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanyDetailed
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailed
     */
    readonly userCount: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyDetailed
     */
    readonly claimCount: number;
}

/**
 * Check if a given object implements the CompanyDetailed interface.
 */
export function instanceOfCompanyDetailed(value: object): value is CompanyDetailed {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('userCount' in value) || value['userCount'] === undefined) return false;
    if (!('claimCount' in value) || value['claimCount'] === undefined) return false;
    return true;
}

export function CompanyDetailedFromJSON(json: any): CompanyDetailed {
    return CompanyDetailedFromJSONTyped(json, false);
}

export function CompanyDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'stripeCustomerId': json['stripeCustomerId'] == null ? undefined : json['stripeCustomerId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'userCount': json['userCount'],
        'claimCount': json['claimCount'],
    };
}

export function CompanyDetailedToJSON(json: any): CompanyDetailed {
    return CompanyDetailedToJSONTyped(json, false);
}

export function CompanyDetailedToJSONTyped(value?: Omit<CompanyDetailed, 'id'|'stripeCustomerId'|'createdAt'|'updatedAt'|'userCount'|'claimCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'domain': value['domain'],
        'address': value['address'],
        'phone': value['phone'],
    };
}

